"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AscIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.AscIcon = (0, react_1.forwardRef)(function AscIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.3136 6.82227C8.23565 6.93482 8.19 7.06657 8.18159 7.20322C8.17319 7.33988 8.20235 7.47622 8.26591 7.59748C8.32948 7.71874 8.42503 7.82029 8.54219 7.89112C8.65936 7.96194 8.79368 7.99934 8.9306 7.99927H11.0006V19.9993C11.0006 20.2645 11.106 20.5188 11.2935 20.7064C11.481 20.8939 11.7354 20.9993 12.0006 20.9993C12.2658 20.9993 12.5202 20.8939 12.7077 20.7064C12.8952 20.5188 13.0006 20.2645 13.0006 19.9993V7.99927H15.0676C15.2045 7.99934 15.3388 7.96194 15.456 7.89112C15.5732 7.82029 15.6687 7.71874 15.7323 7.59748C15.7958 7.47622 15.825 7.33988 15.8166 7.20322C15.8082 7.06657 15.7625 6.93482 15.6846 6.82227L12.6156 2.39027C12.5466 2.29064 12.4544 2.20922 12.3471 2.15299C12.2397 2.09676 12.1203 2.06738 11.9991 2.06738C11.8779 2.06738 11.7585 2.09676 11.6511 2.15299C11.5438 2.20922 11.4516 2.29064 11.3826 2.39027L8.3136 6.82227Z", fill: "currentColor" })));
});
